import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M24.999 12v.939a5.86 5.86 0 0 0 .924 3.165l1.477 2.297c1.348 2.099.319 4.95-2.027 5.614a34.4 34.4 0 0 1-18.746 0C4.281 23.352 3.252 20.5 4.6 18.401l1.477-2.297a5.86 5.86 0 0 0 .924-3.165v-.94c0-5.154 4.03-9.333 8.999-9.333s8.999 4.18 8.999 9.334",
      opacity: ".5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.658 24.727a6.67 6.67 0 0 0 12.685 0c-4.194.787-8.49.787-12.685 0"
    }, null, -1)
  ])))
}
export default { render: render }